module.exports = __webpack_public_path__ + "static/media/icn_info_red.26be5b1f.svg";